import { lazy } from 'react';

const ReturnAddressModal = lazy(() =>
  import('modules/CollegeAppConfig/modals/ReturnAddressModal'),
);

export default {
  RETURN_ADDRESS_MODAL: ReturnAddressModal,
}
